import { render, staticRenderFns } from "./Selectable.vue?vue&type=template&id=c1064da4&scoped=true&"
import script from "./Selectable.vue?vue&type=script&lang=js&"
export * from "./Selectable.vue?vue&type=script&lang=js&"
import style0 from "./Selectable.vue?vue&type=style&index=0&id=c1064da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1064da4",
  null
  
)

export default component.exports